const HISTORY_STATE = {
  state: [],
  current: undefined,
  active_tab: undefined,
};

export default HISTORY_STATE;
